import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export const StatCard = ({ title, value, maxValue, subtitle }) => (
  <div className="flex flex-col items-center">
    <div className="w-32 h-32 relative">
      <CircularProgressbar
        value={value}
        maxValue={maxValue}
        styles={buildStyles({
          textColor: "#fff",
          pathColor: "#CBDF52",
          trailColor: "#AAAAAA",
          textSize: "12px",
        })}
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-[#FFFFFF] text-sm font-semibold">
        <span className="text-xl">{value}</span>
        <span className="text-xs">{title}</span>
      </div>
    </div>
    <p className="text-xs text-[#FFFFFF] mt-1 text-center">{subtitle}</p>
  </div>
);

export const SimpleStatCard = ({ title, value, subtitle }) => (
  <div className="bg-[#232222] text-[#FFFFFF] p-4 rounded-2xl text-center w-48">
    <div className="text-5xl font-bold text-lime-300">{value}</div>
    <div className="text-sm text-[#FFFFFF] mt-1">{title}</div>
    <div className="text-xs text-[#FFFFFF] mt-2">{subtitle}</div>
  </div>
);
